export const GENERATE_ARN_LINK = "GENERATE_ARN_LINK";
export const GENERATE_ARN_LINK_SUCCESS = "GENERATE_ARN_LINK_SUCCESS";
export const GENERATE_ARN_LINK_FAILED = "GENERATE_ARN_LINK_FAILED";
